import { Responsive } from 'semantic-ui-react';

export const useIsMobileView = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};